import { createReducer } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import {
    CurrencySchema,
    fetchCurrenciesAction,
    fetchCurrenciesFailedAction,
    fetchCurrenciesSuccessAction,
} from '../actions';

type CurrencyState = {
    currency: {
        byId: { [id: string]: CurrencySchema };
        allIds: Array<string | any>;
    };
    loading: boolean;
};

const INITIAL_STATE: CurrencyState = {
    currency: {
        byId: {},
        allIds: [],
    },
    loading: false,
};

const fetchCurrencies = (
    state: CurrencyState,
    action: fetchCurrenciesAction,
): CurrencyState => {
    return {
        ...state,
        loading: true,
    };
};

const fetchCurrenciesSuccess = (
    state: CurrencyState,
    action: fetchCurrenciesSuccessAction,
): CurrencyState => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'code',
        action.payload?.body?.data,
    );

    return {
        ...state,
        loading: false,
        currency: {
            ...state.currency,
            byId: byId,
            allIds: allIds,
        },
    };
};

const fetchCurrenciesFailed = (
    state: CurrencyState,
    action: fetchCurrenciesFailedAction,
): CurrencyState => {
    return {
        ...state,
        loading: false,
    };
};

const currency = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_CURRENCIES]: fetchCurrencies,
    [ActionTypes.FETCH_CURRENCIES_SUCCESS]: fetchCurrenciesSuccess,
    [ActionTypes.FETCH_CURRENCIES_FAILED]: fetchCurrenciesFailed,
});

export default currency;
